import { render } from "./guiasPendentes.vue?vue&type=template&id=7b61b0ee&scoped=true"
import script from "./guiasPendentes.vue?vue&type=script&lang=js"
export * from "./guiasPendentes.vue?vue&type=script&lang=js"

import "./guiasPendentes.vue?vue&type=style&index=0&id=7b61b0ee&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b61b0ee"]])

export default __exports__